let $ = require("jquery");
import 'slick-carousel';

// Prismic	
let Prismic = require('prismic-javascript');
const $main = document.querySelector('main')
 
let apiEndpoint = "https://olivier-geffard.prismic.io/api/v2";
 
Prismic.getApi(apiEndpoint).then(function(api) {
  return api.getByID('Xi3D5BAAACAA91JZ'); // An empty query will return all the documents
}).then(function(response) {
  const sliders = response.data.sliders

  sliders.forEach((slider, index) => {
    const $slider = document.createElement('div')
    $slider.classList.add('slider_container')
    const $title = document.createElement('h2')
    const $sliderImages = document.createElement('div')
    $sliderImages.classList.add('slider')
    $sliderImages.classList.add('gallery')

    $title.innerHTML = slider.carnet_title[0].text
    $slider.appendChild($title)

    Object.keys(slider).forEach(image => {
      if(slider[image].url) {
          const img = document.createElement('img')
          img.setAttribute('src', slider[image].url)
          img.setAttribute('alt', slider[image].alt)
          $sliderImages.appendChild(img)
      }
    })
    $slider.appendChild($sliderImages)
    if (sliders.length == index + 1) {
      const endText = document.createElement('p')
      endText.innerHTML = "Pour toute <strong>commande</strong> : Veuillez m'envoyer un e-mail avec le nom du carnet."
      $slider.appendChild(endText)
    }
    $main.appendChild($slider)
  })

  $('.slider').slick({
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true
});

}, function(err) {
  console.log("Something went wrong: ", err);
});
